<template>
  <HeadlessLayout :sections="content" />
</template>

<script>
import SustainabilityOurApproachContent from "@/content/SustainabilityOurApproach.json";
import HeadlessLayout from "@/layouts/HeadlessLayout.vue";

export default {
  name: "Approach",
  components: {
    HeadlessLayout,
  },
  data() {
    return {
      content: SustainabilityOurApproachContent,
    };
  },
};
</script>
